/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseCategoryCardGridFragment} from '@amblique/contentful/app/contentful/fragments/category-card-grid/base-category-card-grid.fragment';
import {CardFragment} from '@amblique/contentful/app/contentful/fragments/card/card.fragment';

export const FullCategoryCardGridFragment = gql`
  ${BaseCategoryCardGridFragment}
  ${CardFragment}

  fragment FullCategoryCardGridFragment on CategoryCardGrid {
    ...BaseCategoryCardGridFragment

    cardItemsCollection {
      items {
        __typename
        ... on Card {
          ...CardFragment
        }
      }
    }
    cardItemsCursorCollection {
      items {
        __typename
        ... on Card {
          ...CardFragment
        }
      }
    }
  }
`;
